import { useAuthLinks, useAuthState } from 'services/Authentication'
import { useEffect } from 'react'
import { KeycloakLogger } from 'services/Logger'

export const useLoginRequired = () => {
	const { userType, state } = useAuthState()
	const { login } = useAuthLinks()
	useEffect(() => {
		if (userType === 'anonymous' && state === 'authenticated') {
			KeycloakLogger.error('redirecting to login as user is not authenticated')
			login()
		}
	}, [userType, state, login])
}
